import { Breakpoints, styled } from '@vw-marketing/us-components';

export const StyledSalesEventLogoWrapper: any = styled.div`
  ${({ theme }) => {
    return `
      img {
        max-width: ${theme.size.grid009};
        max-height: ${theme.size.dynamic0300};

        @media (min-width: ${Breakpoints.b560}px) {
          max-width: ${theme.size.grid007};
        }

        @media (min-width: ${Breakpoints.b960}px) {
          max-height: ${theme.size.dynamic0350};
          max-width: ${theme.size.grid004};
          padding-bottom: ${theme.size.static300};
        }

        @media (min-width: ${Breakpoints.b1280}px) {
          max-width: 214px;
        }
      
        @media (min-width: ${Breakpoints.b1600}px) {
          max-width: 267px;
        }
      }
    `;
  }}
`;

export const StyledMlpTittleWrapper: any = styled.div`
  ${({ theme }) => {
    return `
      align-items: flex-start;
      display: flex;
      gap: ${theme.size.static150};
      
      @media (max-width: 959px) {
        align-items: center;
      }

      @media (min-width: ${Breakpoints.b960}px) {
        flex-wrap: wrap;
        width: 160px;
      }

      @media (min-width: ${Breakpoints.b1280}px) {
        flex-wrap: nowrap;
        gap: ${theme.size.static200};
        width: 213px;

        p {
          padding-top: 8px;
        }
      }

      @media (min-width: ${Breakpoints.b1600}px) {
        width: 267px;
      }
    `;
  }}
`;
